import {
  DashboardOutlined,
  ShoppingCartOutlined,
  ShoppingOutlined,
  BarChartOutlined,
  LogoutOutlined,
  StarOutlined,
  UserOutlined,
  TagsOutlined,
  FileImageOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";

export const MenusDynamic = [
  {
    key: "1",
    icon: <DashboardOutlined />,
    label: <Link to="/admin/">Dashboard</Link>,
    path: "/admin/",
  },
  {
    key: "banner_1",
    icon: <FileImageOutlined />,
    label: "Banner",
    path: "/admin/banner",
    children: [
      {
        key: "banner_13a",
        icon: null,
        label: <Link to="/admin/banner/banner">Banner</Link>,
        path: "/admin/banner/banner",
      },
    ],
  },
  {
    key: "3",
    icon: <ShoppingCartOutlined />,
    label: "Products",
    path: "/admin/products",
    children: [
      {
        key: "3a",
        icon: null,
        label: <Link to="/admin/products/brands">Brands</Link>,
        path: "/admin/products/brands",
      },
      {
        key: "3b",
        icon: null,
        label: <Link to="/admin/products/category">Category</Link>,
        path: "/admin/products/category",
      },
      {
        key: "3c",
        icon: null,
        label: <Link to="/admin/products/products">Products</Link>,
        path: "/admin/products/products",
      },
      {
        key: "3e",
        icon: null,
        label: <Link to="/admin/products/couriers">Courier Partners</Link>,
        path: "/admin/products/couriers",
      },
    ],
  },
  {
    key: "9111",
    icon: <UserOutlined />,
    label: <Link to="/admin/customers">Customers</Link>,
    path: "/admin/customers",
  },
  {
    key: "911",
    icon: <StarOutlined />,
    label: <Link to="/admin/ratings">Ratings</Link>,
    path: "/admin/ratings",
  },
  {
    key: "5",
    icon: <TagsOutlined />,
    label: "Free Cash",
    path: "/admin/freecash",
    children: [
      {
        key: "5a",
        icon: null,
        label: <Link to="/admin/freecash">Free Cash</Link>,
        path: "/admin/freecash",
      },
      {
        key: "5b",
        icon: null,
        label: <Link to="/admin/freecash/history">Free Cash History</Link>,
        path: "/admin/freecash/history",
      },
    ],
  },
  {
    key: "7",
    icon: <ShoppingOutlined />,
    label: "Orders",
    path: "/admin/orders",
    children: [
      {
        key: "7a",
        icon: null,
        label: <Link to="/admin/orders/sales">Orders</Link>,
        path: "/admin/orders/sales",
      },
      {
        key: "7a11",
        icon: null,
        label: <Link to="/admin/orders/reorders">Orders Returns</Link>,
        path: "/admin/orders/reorders",
      },
      {
        key: "7c",
        icon: null,
        label: <Link to={void 0}>Payment History</Link>,
        path: "/admin/orders/payment_history",
      },
    ],
  },
  {
    key: "8",
    icon: <BarChartOutlined />,
    label: "Analytics",
    path: "/admin/analytics",
    children: [
      {
        key: "8a",
        icon: null,
        label: <Link to={"/admin/analytics/overview"}>Overview</Link>,
        path: "/admin/analytics/overview",
      },
      {
        key: "8b",
        icon: null,
        label: <Link to={"/admin/analytics/products"}>Products</Link>,
        path: "/admin/analytics/products",
      },
      {
        key: "8d",
        icon: null,
        label: <Link to={"/admin/analytics/orders"}>Orders</Link>,
        path: "/admin/analytics/orders",
      },
      {
        key: "8f",
        icon: null,
        label: <Link to={"/admin/analytics/customers"}>Customers</Link>,
        path: "/admin/analytics/customers",
      },
      {
        key: "8g",
        icon: null,
        label: <Link to={"/admin/analytics/monthly_report"}>Reports</Link>,
        path: "/admin/analytics/monthly_report",
      },
    ],
  },
  {
    key: "9",
    icon: <LogoutOutlined />,
    label: "Logout",
    path: "/admin/logout",
  },
];

export const MenusDynamicStaff = [
  {
    key: "7",
    icon: <ShoppingOutlined />,
    label: "Orders",
    path: "/admin/orders",
    children: [
      {
        key: "7a",
        icon: null,
        label: <Link to="/admin/orders/sales">Orders</Link>,
        path: "/admin/orders/sales",
      },
      {
        key: "7a11",
        icon: null,
        label: <Link to="/admin/orders/reorders">Orders Returns</Link>,
        path: "/admin/orders/reorders",
      },
    ],
  },
  {
    key: "9",
    icon: <LogoutOutlined />,
    label: "Logout",
    path: "/admin/logout",
  },
];
